var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    {
      staticClass: "notifications-modal",
      class: { small: _vm.$wf.isMdDown },
      attrs: { "max-width": "700" },
    },
    [
      _c(
        "w-card-title",
        { staticClass: "head", attrs: { plain: "" } },
        [
          _c(
            "w-tab",
            {
              attrs: { plain: "", active: _vm.tab == 0 },
              on: {
                click: function ($event) {
                  return _vm.setTab(0)
                },
              },
            },
            [
              _vm._v(" " + _vm._s(_vm.$ct("title")) + " "),
              _vm.unreadCount > 0
                ? _c("span", { staticClass: "count" }, [
                    _vm._v(_vm._s(_vm.unreadCount)),
                  ])
                : _vm._e(),
            ]
          ),
          _c(
            "w-tab",
            {
              attrs: { plain: "", active: _vm.tab == 1 },
              on: {
                click: function ($event) {
                  return _vm.setTab(1)
                },
              },
            },
            [
              _vm._v(" " + _vm._s(_vm.$ct("title-jobs")) + " "),
              _vm.activeJobs.length > 0
                ? _c("span", { staticClass: "count" }, [
                    _vm._v(_vm._s(_vm.activeJobs.length)),
                  ])
                : _vm._e(),
            ]
          ),
          _c("w-spacer"),
          _c("w-button", {
            staticClass: "close",
            attrs: { flat: "", round: "", icon: "times" },
            on: {
              click: function ($event) {
                return _vm.close()
              },
            },
          }),
        ],
        1
      ),
      _vm.tab == 0
        ? [
            _c(
              "div",
              { staticClass: "filters" },
              [
                _vm._l(_vm.filterItems, function (f) {
                  return _c(
                    "w-chip",
                    {
                      key: f.value,
                      attrs: { filter: "", active: _vm.filter == f.value },
                      on: {
                        click: function ($event) {
                          _vm.filter = f.value
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(f.text) + " ")]
                  )
                }),
                _c("w-spacer"),
                _c(
                  "w-link",
                  {
                    staticClass: "mark-read",
                    attrs: { disabled: _vm.unreadCount == 0 },
                    on: {
                      click: function ($event) {
                        return _vm.markAllNotificationsAsRead()
                      },
                    },
                  },
                  [
                    _c("w-fa", {
                      staticClass: "mrs",
                      attrs: { icon: "check-double" },
                    }),
                    _vm._v(_vm._s(_vm.$ct("mark-all-as-read-short")) + " "),
                  ],
                  1
                ),
              ],
              2
            ),
            _vm.groups.length == 0
              ? _c(
                  "w-card-content",
                  { staticClass: "no-content", attrs: { center: "" } },
                  [
                    _c("div", [_c("w-fa", { attrs: { icon: "check" } })], 1),
                    _c("div", [_vm._v(_vm._s(_vm.$ct("no-content")))]),
                  ]
                )
              : _c(
                  "w-scroll-view",
                  {
                    staticClass: "list",
                    attrs: { grow: "" },
                    nativeOn: {
                      scroll: function ($event) {
                        return _vm.onScroll($event)
                      },
                    },
                  },
                  [
                    _vm._l(_vm.groups, function (group) {
                      return [
                        _c("w-list-subheader", { key: group.key }, [
                          _vm._v(" " + _vm._s(group.label) + " "),
                        ]),
                        _vm._l(group.items, function (item) {
                          return [
                            item.ticket
                              ? _c(
                                  "w-notification-item",
                                  {
                                    key: "ticket-" + item.ticket.id,
                                    attrs: {
                                      icon: "life-ring",
                                      tone: "info",
                                      unread: "",
                                      clickable: "",
                                      title: _vm.$ct("new-ticket-message", {
                                        text: item.ticket.subject,
                                      }),
                                      subtitle: item.ticket.dossierName
                                        ? _vm.$ct("ticket-subtitle", {
                                            dossier: item.ticket.dossierName,
                                          })
                                        : "",
                                      time: _vm.formatTime(
                                        item.ticket.timeLastMessage
                                      ),
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openTicket(item.ticket)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        attrs: { sm: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openTicket(item.ticket)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$ct("open-ticket")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : [
                                  _c("app-notification", {
                                    key: "n-" + item.notifications[0].ID,
                                    attrs: {
                                      value: item.notifications[0],
                                      count: item.notifications.length,
                                      expanded: !!_vm.expanded[item.key],
                                    },
                                    on: {
                                      toggle: function ($event) {
                                        return _vm.toggleGroup(item.key)
                                      },
                                      close: function ($event) {
                                        return _vm.close()
                                      },
                                      "open-report-download": function (
                                        $event
                                      ) {
                                        _vm.downloadReportItem = $event
                                      },
                                    },
                                  }),
                                  item.notifications.length > 1 &&
                                  _vm.expanded[item.key]
                                    ? _vm._l(
                                        item.notifications.slice(1),
                                        function (notification) {
                                          return _c("app-notification", {
                                            key: "n-" + notification.ID,
                                            staticClass: "repeat",
                                            attrs: { value: notification },
                                            on: {
                                              close: function ($event) {
                                                return _vm.close()
                                              },
                                              "open-report-download": function (
                                                $event
                                              ) {
                                                _vm.downloadReportItem = $event
                                              },
                                            },
                                          })
                                        }
                                      )
                                    : _vm._e(),
                                ],
                          ]
                        }),
                      ]
                    }),
                  ],
                  2
                ),
            _c(
              "w-card-actions",
              { staticClass: "foot" },
              [
                _c(
                  "span",
                  { staticClass: "meta" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$ctc("notification-count", _vm.totalCount, {
                            count: _vm.totalCount,
                          })
                        ) +
                        " "
                    ),
                    _vm.unreadCount > 0
                      ? [
                          _vm._v(
                            " · " +
                              _vm._s(
                                _vm.$ct("unread-count", {
                                  count: _vm.unreadCount,
                                })
                              )
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c("w-spacer"),
                _c(
                  "w-button",
                  {
                    staticClass: "danger clear-read",
                    attrs: {
                      ghost: "",
                      icon: "trash",
                      disabled: _vm.readCount == 0,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.deleteAllReadNotifications()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$ct("delete-all-read-short")) + " ")]
                ),
              ],
              1
            ),
          ]
        : _vm.tab == 1
        ? _c("app-notification-job-list")
        : _vm._e(),
      _vm.downloadReportItem
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-download-report-modal", {
                attrs: { value: _vm.downloadReportItem.Data },
                on: {
                  close: function ($event) {
                    _vm.downloadReportItem = null
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }